export const SHOW_COMMENT = 'SHOW_COMMENT';
export const HIDE_COMMENT = 'HIDE_COMMENT';

export const SHOW_BLOCKED_COMMENT_POPUP = 'SHOW_BLOCKED_COMMENT_POPUP';
export const HIDE_BLOCKED_COMMENT_POPUP = 'HIDE_BLOCKED_COMMENT_POPUP';

export const EMO_REACTION_START = 'EMO_REACTION_START';
export const EMO_REACTION_FAIL = 'EMO_REACTION_FAIL';
export const EMO_REACTION_SUCCESS = 'EMO_REACTION_SUCCESS';

export const RETRIEVE_ARTICLE_REACTIONS_START = 'RETRIEVE_ARTICLE_REACTION_START';
export const RETRIEVE_ARTICLE_REACTIONS_SUCCESS = 'RETRIEVE_ARTICLE_REACTION_SUCCESS';
export const RETRIEVE_ARTICLE_REACTIONS_FAIL = 'RETRIEVE_ARTICLE_REACTION_FAIL';

export const RETRIEVE_ARTICLE_CONTENT_START = 'RETRIEVE_ARTICLE_CONTENT_START';
export const RETRIEVE_ARTICLE_CONTENT_SUCCESS = 'RETRIEVE_ARTICLE_CONTENT_SUCCESS';
export const RETRIEVE_FAKE_ARTICLE_CONTENT_SUCCESS = 'RETRIEVE_FAKE_ARTICLE_CONTENT_SUCCESS';
export const RETRIEVE_ARTICLE_CONTENT_FAIL = 'RETRIEVE_ARTICLE_CONTENT_FAIL';

export const RETRIEVE_ARTICLE_EMO_REACTION_START = 'RETRIEVE_ARTICLE_EMO_REACTION_START';
export const RETRIEVE_ARTICLE_EMO_REACTION_SUCCESS = 'RETRIEVE_ARTICLE_EMO_REACTION_SUCCESS';
export const RETRIEVE_ARTICLE_EMO_REACTION_FAIL = 'RETRIEVE_ARTICLE_EMO_REACTION_FAIL';


// WEBPACK FOOTER //
// ./src/components/Article/articleActionTypes.js